import {Component} from "react";
import {connect} from "react-redux";
import * as actions from "../../../store/actions/index";
import moment from "moment";
import {Avatar, Box, Button, Divider, IconButton, InputAdornment, TextField, Theme} from '@material-ui/core/';
import {green} from '@material-ui/core/colors';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ValidateForm from "../../../helper/validations";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import TimezonePicker from 'react-timezone';
import {Auth} from "aws-amplify";
import jwtDecode from "jwt-decode";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import {withStyles} from '@material-ui/core/styles'
import {Styles} from "@material-ui/core/styles/withStyles";
import CustomDropzone from "../../../helper/customDropzone";
import UtilService from "../../../helper/service";
import {Link, Prompt, withRouter} from 'react-router-dom';
import CustomSnackBar from '../creator/experienceManager/participantsDashboard/component/CustomSnackBar';
import Config from '../../../config/config';

const CssTextField = withStyles({
  root: {
    width: 250,
    marginRight: 40,
    fontSize: 24,
    '& label': {
      fontSize: 14,
      color: '#697683',
      fontWeight: '700'
    },
    '& input': {
      fontSize: 14,
      fontWeight: '400',
      color: '#8F99A3',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#697683',
      borderBottomWidth: 1.6,
    },
    "& .MuiInputBase-root.Mui-disabled:before": {
      borderBottom: '1.6px solid #697683'
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: '#8F99A3',
      opacity: 0.7,
      '-webkit-text-fill-color': '#8F99A3',
      '-webkit-opacity': 0.7
    }
  },
})(TextField);

const useStyles: Styles<Theme, any, any> = (theme) => ({
  advanced: {
    color: "#697683",
    fontSize: 14,
    fontWeight: 600,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  actived: {
    color: '#017AEF',
    fontSize: 14,
    fontWeight: 600,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  advancedView: {
    background: '#f8f8f8',
    borderRadius: 18,
    padding: 20,
    marginLeft: 16
  },
  deactive: {
    touchAction: 'none',
    opacity: 0.6,
    pointerEvents: 'none'
  },
  label: {
    "&$focusedLabel": {
      color: "#707070"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#2D2D2D',
    "&$error:after": {
      borderBottomColor: "#017AEF"
    },
    "&:after": {
      borderBottom: `2px solid #017AEF`
    }
  },
  passwordCheckRow: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 300,
    fontFamily: 'roboto-regular',
    textAlign: "left",
  },
  name: {
    marginTop: theme.spacing(1)
  },
  avatar: {
    height: 150,
    width: 150,
    cursor: 'pointer',
    border: '5px solid #707070'
  },
  passwordInput: {
    width: '100%',
    "& .MuiInputAdornment-positionEnd": {
      margin: "0!important",
    }
  },
  img: {
    border: '1px solid grey',
    borderRadius: 4,
    marginTop: 20
  },
  timezone: {
    fontSize: 12,
    fontFamily: 'roboto-black',
    color: '#606B76',
    marginTop: theme.spacing(5)
  },
  dialog: {
    borderRadius: '24px!important'
  },
  btnOK: {
    width: 80,
    height: 36,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 16,
    marginLeft: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
  btnCancel: {
    width: 80,
    height: 36,
    borderRadius: 6,
    background: '#dc0044',
    color: '#fff',
    textTransform: 'none',
    fontSize: 16,
    marginLeft: 14,
    '&:hover': {
      background: '#c22154',
      color: '#fff',
    },
  },
  header: {
    color: '#606B76',
    fontFamily: 'Spartan-bold',
    fontSize: 24,
    paddingLeft: 17,
    paddingBottom: 7,
    margin:0
  },
  updateBtn:{
    marginBottom:20
  },
  toggleLabel: {
    fontSize: '14px',
    fontFamily: 'roboto-regular',
    color: '#606B76'
  },
  anchorLink: {
    textDecoration: 'none',
    color: '#017AEF'
  }
});

interface IProps {
  classes: any;
  authUser: any;
  path: string;
  isTrial: boolean;
  isTeamOwner: boolean;
  globalSaveSetting: boolean;
  globalCompatible: number;
  notification: any;
  createUserPreference: any;
  updateUserPreference: any;
  apolloClient: any;
  history: any;
  updateUserProfile: any;
  getUserProfile: (client: any, request: any, history: any ) => void;
  getUserPreferences: (client: any, request: any, history: any ) => void;
  changePassWordFromProfile: (client: any, request: any, history: any ) => void;
  updateUserProfilePicture: (client: any, request: any ) => void;
  updateDepartment: (client: any, request: any, cb: any) => void;
  sendNeedHelpEmail: (client: any, request: any, cb: any) => void;
  mutationUpdateUserMetricValue: (client: any, request: any) => void;
  getGravatarImage: (client: any, request: any) => void;
}

interface IState {
  profileSetting: any;
  selectedTab: string;
  advanced: boolean;
  open: boolean;
  errors: any;
  user_data: any;
  is_loaded: boolean;
  screen_loader: boolean;
  CurrentPass: string;
  NewPass: string;
  newPasswordAgain: string;
  isPasswordShown: boolean;
  isPasswordNewPass: boolean;
  isPasswordShownAgain: boolean;
  loading: boolean;
  is_length: boolean;
  is_uppercase: boolean;
  is_lowercase: boolean;
  is_number: boolean;
  // is_special_character: boolean;
  is_confirm: boolean;
  loginUserData: any;
  firstName: any;
  lastName: any;
  newDepartmentAlias: any;
  isTrial: boolean;
  isTeamOwner: boolean;
  imagePreview: string;
  userPreferencesData: any;
  cognitoUsername: string;
  [key: string]: any;
  openProfilePicture:boolean;
  selectedProfileImage:any;
  uploadProfileImageError:string;
  userProfile:string;
  snackAlertType: string;
  snackAlertMsg: string;
  isShownSnackAlert: boolean;
}

class UserProfile extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      selectedTab: props.path ? props.path : 'account',
      advanced: false,
      open: false,
      errors: { email: "", CurrentPass: "", NewPass: "", mobile: "", timezone: "", first_name: "", last_name: "" },
      user_data: "",
      is_loaded: false,
      screen_loader: false,
      CurrentPass: "",
      NewPass: "",
      newPasswordAgain: "",
      isPasswordShown: false,
      isPasswordNewPass: false,
      isPasswordShownAgain: false,
      loading: false,
      is_length: false,
      is_number: false,
      is_lowercase: false,
      is_uppercase: false,
      // is_special_character: false,
      is_confirm: false,
      loginUserData: JSON.parse(localStorage.getItem("user_data") || "{}"),
      firstName: localStorage.getItem('firstName') ? localStorage.getItem('firstName') : '',
      lastName: localStorage.getItem('lastName') ? localStorage.getItem('lastName') : '',
      newDepartmentAlias: localStorage.getItem("departmentAlias") ? localStorage.getItem("departmentAlias") : "",
      isTrial: props.isTrial,
      isTeamOwner: props.isTeamOwner,
      imagePreview: "/assets/img/profile-pic.jpg",
      userProfile:"/static/profile.png",
      profileSetting: {
        email: "",
        first_name: "",
        last_name: "",
        middle_name: "",
        mobile_number: "",
        mfa_enabled: false,
        createddate: moment(),
        editeddate: moment(),
        selectedRadio: 0,
        MARKETINGEMAIL: true,
        sso_enabled: true,
        individual_immersion_emails: true,
        summary_immersion_emails: true,
        HELPTOMEASURE: false,
        WANTTOPARTICIPANTE: false,
        ASKEVERYTIME: true,
        ALLOWPERSONAL: true,
        ALLOWAGGREGATE: true,
        AUTOJOIN: true,
        AUTOSTART: true,
        APPNOTIFY: true,
        SMSNOTIFY: true,
        EMAILNOTIFY: true,
        DESKNOTIFY: true,
        country: "US",
        customername: "",
        PERSONALEMAIL: true,
        AGGREGATEEMAIL: true,
        RESOURCEEMAIL: true,
        ANONYMOUS: false,
        CALENDAR: false,
        MODERATED: true,
        ASYNC: true,
        VIDEOSECURITY: false,
        organization: "",
        role: "",
        TIMEZONE: false,
        timezone_value: Intl.DateTimeFormat().resolvedOptions().timeZone,
        imageSrc: "",
        image: ""
      },
      userPreferencesData: [],
      cognitoUsername: "",
      openProfilePicture:false,
      selectedProfileImage:false,
      uploadProfileImageError:"",
      fieldChanged:false,
      confirmationLeavePage:false,
      snackAlertType: "",
      snackAlertMsg: "",
      isShownSnackAlert: false,
    };
  }

  componentDidMount() {
    document.body.classList.add("right-menu");
    this.getUserProfile();
    this.getUserPreferences();
    this.setState(
      {
        profileSetting: {
          ...this.state.profileSetting,
          "customername": this.props.authUser.userInfo.name,
        },
        user_data: JSON.parse(localStorage.getItem("user_data") || "{}"),
      },
      () => this.forceUpdate()
    );
    Auth.currentAuthenticatedUser().then(async (user) => {
      const decoded: any = jwtDecode(user.signInUserSession.idToken.jwtToken);
      if (decoded['cognito:username']) {
        this.setState({ cognitoUsername: decoded['cognito:username'] })
      }
    })
  }

  UNSAFE_componentWillReceiveProps(props: IProps) {
    if (props.path) {
      this.setState({ selectedTab: props.path })
    }
    if (props.notification) {
      if (this.state.loading) {
        if (props.notification.success) {
          this.setState({
            snackAlertType: "success",
            snackAlertMsg: "Settings successfully updated",
            isShownSnackAlert: true
          })
        } else {
          this.setState({
            snackAlertType: "error",
            snackAlertMsg: "Problem occured while update settings",
            isShownSnackAlert: true
          })
        }
        props.notification.success = false
      }      
      this.setState({
        loading: false,
        screen_loader: false,
      })
      if(this.state.open){
        if(props.authUser.changePasswordStatus){
          if (props.authUser.changePasswordStatus.status) {
            this.setState({
              snackAlertType: "success",
              snackAlertMsg: props.authUser.changePasswordStatus.message,
              isShownSnackAlert: true
            })
            this.handleClose()
          } else {
            this.setState({
              snackAlertType: "error",
              snackAlertMsg: props.authUser.changePasswordStatus.message,
              isShownSnackAlert: true,
              is_loaded: false,
            })
          }
          props.authUser.changePasswordStatus = null
        }
      }
      if(this.state.openProfilePicture){
        if(!props.notification.success){
          this.setState({
            uploadProfileImageError:props.notification.message
          })
        } else {
          this.setState({
            uploadProfileImageError:"",
            openProfilePicture:false
          })
        }
      }
    }

    // get user profile and user preferences data
    if (props.authUser.userProfileData && props.authUser.userPreferencesData.length > 0) {
      const profileData = props.authUser.userProfileData;

      this.setState(
        {
          loading: false,
          profileSetting: {
            ...this.state.profileSetting,
            "first_name": profileData.first_name,
            "last_name": profileData.last_name,
            "middle_name": profileData.middle_name,
            "email": profileData.username,
            "createddate": moment(profileData.created_at),
            "editeddate": moment(profileData.updated_at),
            "sso_enabled": profileData.sso_enabled,
            "country": "in",
            "mobile_number": profileData.mfa_number ? profileData.mfa_number?.toString() : "",
            "organization": this.state.isTrial ?
              (localStorage.getItem("departmentAlias") ? localStorage.getItem("departmentAlias") : this.state.loginUserData.department_alias)
              : this.state.loginUserData.customer_display_name,
            // "role": this.state.loginUserData.system_flagged ? 'Tenant Admin' : this.state.loginUserData.role_name,
            "role": this.state.loginUserData.role_description,
            "mfa_enabled": profileData.mfa_enabled
          },
        },
        () => {
          props.authUser.userProfileData = false
          this.forceUpdate();
          const preferencesData = props.authUser.userPreferencesData;
          if (preferencesData) {
            this.setState(
              {
                profileSetting: {
                  ...this.state.profileSetting,
                  "MARKETINGEMAIL": preferencesData.filter((data: any) => data.preference_name === "MARKETINGEMAIL").length ? (preferencesData.filter((data: any) => data.preference_name === "MARKETINGEMAIL"))[0].preference_value : this.state.profileSetting.MARKETINGEMAIL,
                  "HELPTOMEASURE": preferencesData.filter((data: any) => data.preference_name === "HELPTOMEASURE").length ? (preferencesData.filter((data: any) => data.preference_name === "HELPTOMEASURE"))[0].preference_value : this.state.profileSetting.HELPTOMEASURE,
                  "WANTTOPARTICIPANTE": preferencesData.filter((data: any) => data.preference_name === "WANTTOPARTICIPANTE").length ? (preferencesData.filter((data: any) => data.preference_name === "WANTTOPARTICIPANTE"))[0].preference_value : this.state.profileSetting.WANTTOPARTICIPANTE,
                  "ASKEVERYTIME": preferencesData.filter((data: any) => data.preference_name === "ASKEVERYTIME").length ? (preferencesData.filter((data: any) => data.preference_name === "ASKEVERYTIME"))[0].preference_value : this.state.profileSetting.ASKEVERYTIME,
                  "TIMEZONE": preferencesData.filter((data: any) => data.preference_name === "TIMEZONE").length ? (preferencesData.filter((data: any) => data.preference_name === "TIMEZONE"))[0].preference_value : this.state.profileSetting.TIMEZONE,
                  "timezone_value": preferencesData.filter((data: any) => data.preference_name === "TIMEZONE").length ? (preferencesData.filter((data: any) => data.preference_name === "TIMEZONE"))[0].preference_information : this.state.profileSetting.timezone_value,
                  "AGGREGATEEMAIL": preferencesData.filter((data: any) => data.preference_name === "AGGREGATEEMAIL").length ? (preferencesData.filter((data: any) => data.preference_name === "AGGREGATEEMAIL"))[0].preference_value : this.state.profileSetting.AGGREGATEEMAIL,
                  "PERSONALEMAIL": preferencesData.filter((data: any) => data.preference_name === "PERSONALEMAIL").length ? (preferencesData.filter((data: any) => data.preference_name === "PERSONALEMAIL"))[0].preference_value : this.state.profileSetting.PERSONALEMAIL,
                  "RESOURCEEMAIL": preferencesData.filter((data: any) => data.preference_name === "RESOURCEEMAIL").length ? (preferencesData.filter((data: any) => data.preference_name === "RESOURCEEMAIL"))[0].preference_value : this.state.profileSetting.RESOURCEEMAIL,
                  "ALLOWAGGREGATE": preferencesData.filter((data: any) => data.preference_name === "ALLOWAGGREGATE").length ? (preferencesData.filter((data: any) => data.preference_name === "ALLOWAGGREGATE"))[0].preference_value : this.state.profileSetting.ALLOWAGGREGATE,
                  "ALLOWPERSONAL": preferencesData.filter((data: any) => data.preference_name === "ALLOWPERSONAL").length ? (preferencesData.filter((data: any) => data.preference_name === "ALLOWPERSONAL"))[0].preference_value : this.state.profileSetting.ALLOWPERSONAL,
                  "CALENDAR": preferencesData.filter((data: any) => data.preference_name === "CALENDAR").length ? (preferencesData.filter((data: any) => data.preference_name === "CALENDAR"))[0].preference_value : this.state.profileSetting.CALENDAR,
                  "MODERATED": preferencesData.filter((data: any) => data.preference_name === "MODERATED").length ? (preferencesData.filter((data: any) => data.preference_name === "MODERATED"))[0].preference_value : this.state.profileSetting.MODERATED,
                  "ASYNC": preferencesData.filter((data: any) => data.preference_name === "ASYNC").length ? (preferencesData.filter((data: any) => data.preference_name === "ASYNC"))[0].preference_value : this.state.profileSetting.ASYNC,
                  "VIDEOSECURITY": preferencesData.filter((data: any) => data.preference_name === "VIDEOSECURITY").length ? (preferencesData.filter((data: any) => data.preference_name === "VIDEOSECURITY"))[0].preference_value : this.state.profileSetting.VIDEOSECURITY,
                  "AUTOJOIN": preferencesData.filter((data: any) => data.preference_name === "AUTOJOIN").length ? (preferencesData.filter((data: any) => data.preference_name === "AUTOJOIN"))[0].preference_value : this.state.profileSetting.AUTOJOIN,
                  "AUTOSTART": preferencesData.filter((data: any) => data.preference_name === "AUTOSTART").length ? (preferencesData.filter((data: any) => data.preference_name === "AUTOSTART"))[0].preference_value : this.state.profileSetting.AUTOSTART,
                  "APPNOTIFY": preferencesData.filter((data: any) => data.preference_name === "APPNOTIFY").length ? (preferencesData.filter((data: any) => data.preference_name === "APPNOTIFY"))[0].preference_value : this.state.profileSetting.APPNOTIFY,
                  "SMSNOTIFY": preferencesData.filter((data: any) => data.preference_name === "SMSNOTIFY").length ? (preferencesData.filter((data: any) => data.preference_name === "SMSNOTIFY"))[0].preference_value : this.state.profileSetting.SMSNOTIFY,
                  "EMAILNOTIFY": preferencesData.filter((data: any) => data.preference_name === "EMAILNOTIFY").length ? (preferencesData.filter((data: any) => data.preference_name === "EMAILNOTIFY"))[0].preference_value : this.state.profileSetting.EMAILNOTIFY,
                  "DESKNOTIFY": preferencesData.filter((data: any) => data.preference_name === "DESKNOTIFY").length ? (preferencesData.filter((data: any) => data.preference_name === "DESKNOTIFY"))[0].preference_value : this.state.profileSetting.DESKNOTIFY,
                  "ANONYMOUS": preferencesData.filter((data: any) => data.preference_name === "ANONYMOUS").length ? (preferencesData.filter((data: any) => data.preference_name === "ANONYMOUS"))[0].preference_value : this.state.profileSetting.ANONYMOUS,
                },
                userPreferencesData: preferencesData
              },
              () => {
                this.forceUpdate()
                props.authUser.userPreferencesData = false
              }
            );
          }
        }
      );
    }

    let updateLoginUserData = this.state.loginUserData;
    if (props.authUser.userProfileData) {
      if (props.authUser.userProfileData.preferences) {
        const profilePicture = props.authUser.userProfileData.preferences.filter((result:any) => result.preference_name === "PROFILEPIC")
        if (profilePicture.length && profilePicture[0]) {
          if (this.state.userProfile !== profilePicture[0].preference_information) {
            updateLoginUserData = {...this.state.loginUserData, profile_picture: profilePicture[0].preference_information};
            this.setState({
              loginUserData: { ...updateLoginUserData }
            });
            localStorage.setItem('user_data', JSON.stringify(updateLoginUserData));
          }
        }
      }

      const profilePic = UtilService.getUserProfile(updateLoginUserData.profile_picture, props.authUser.userProfileData, props.authUser.userPreferencesData);
      if (profilePic === '/static/profile.png') {
        if (updateLoginUserData && updateLoginUserData.username && localStorage.getItem('sso_login') === "false") {
          this.props.getGravatarImage(this.props.apolloClient.client, {email: updateLoginUserData.username})
        }
      } else {
        this.setState({userProfile: profilePic});
      }

      if (this.state.userProfile === '/static/profile.png' || !this.state.userProfile) {
        if (localStorage.getItem('sso_login') === "true" && props.authUser.googleProfilePicture) {
          this.setState({userProfile: props.authUser.googleProfilePicture})
        }

        if (localStorage.getItem('sso_login') === "false" && props.authUser.gravatarImg) {
          this.setState({userProfile: props.authUser.gravatarImg})
        }
      }
    }
  }

  //event call on change switch
  changeSwitch = (event: any, checked: any) => {
    let errors: any = {};
    if (event.target.name === "TIMEZONE" && checked) {
      if (!this.state.profileSetting.timezone_value) {
        errors["timezone"] = "Please select timezone";
      } else { errors["timezone"] = "" }
    } else {
      errors = {}
    }

    this.setState(
      {
        errors: errors,
        profileSetting: {
          ...this.state.profileSetting,
          [event.target.name]: checked,
        },
        screen_loader: true
      },
      () => {
        this.forceUpdate();
        //if not get any error then hit prefrence update api
        if (!Object.keys(errors).length) {
          const preferencesData = this.state.userPreferencesData
          let pf_id = '';

          pf_id = preferencesData.filter((data: any) => data.preference_name === event.target.name).length ? (preferencesData.filter((data: any) => data.preference_name === event.target.name))[0].preference_id : ""
          const req = {
            preference_value: checked,
            preference_id: pf_id,
            preference_information: Intl.DateTimeFormat().resolvedOptions().timeZone,
            user_id: this.state.loginUserData.user_id
          };

          this.props.updateUserPreference(this.props.apolloClient.client, req, this.props.history);
        } else {
          this.setState({
            errors: errors,
            screen_loader: false

          }, () => this.forceUpdate());
        }

      }
    );
  };
  //input on change event
  handleChange = (event: any) => {
    const input = event.target.value
    const errors = this.state.errors;
    if (input === "") {
      if (event.target.name === "first_name") {
        errors["first_name"] = "Please enter your first name";
      }
    } else if (input !== "" && event.target.name === "first_name") {
      errors["first_name"] = ""
    }

    if (input === "") {
      if (event.target.name === "last_name") {
        errors["last_name"] = "Please enter your last name";
      } else { errors["last_name"] = "" }
    } else if (input !== "" && event.target.name === "last_name") {
      errors["last_name"] = ""
    }

    this.setState(
      {
        errors: {
          ...this.state.errors,
          "last_name": errors["last_name"],
          "first_name": errors["first_name"],
        },
        profileSetting: {
          ...this.state.profileSetting,
          [event.target.name]: event.target.value,
        }
      },
      () => this.forceUpdate()
    );
    this.setState({
      fieldChanged:true
    })
  };

  //api hit on profile submit
  handleProfileSubmit = (e: any) => {
    e.preventDefault()
    const errors: any = {};
    // if (this.state.profileSetting.mobile_number) {
    //   if (this.state.profileSetting.mobile_number.length < 8) {
    //     errors["mobile"] = "Please enter valid mobile number";
    //   }
    // } else {
    //   errors["mobile"] = "Please enter valid mobile number";
    // }


    if (this.state.profileSetting.first_name === "") {
      errors["first_name"] = "Please enter your first name.";
    }

    if (this.state.profileSetting.last_name === "") {
      errors["last_name"] = "Please enter your last name.";
    }

    if (this.state.isTrial && this.state.isTeamOwner) {
      const departmentReq = {
        department_id: Number(this.state.loginUserData.department_id),
        department_alias: this.state.profileSetting.organization
      };
      this.props.updateDepartment(this.props.apolloClient.client, departmentReq, (res: any) => {
        if (res) {
          const newDepartmentAlias = res.updateDepartment.department_alias;
          this.setState({
            profileSetting: {
              ...this.state.profileSetting,
              organization: newDepartmentAlias
            }
          });
          localStorage.setItem('departmentAlias', newDepartmentAlias);
        }
      })
    }

    if (!Object.keys(errors).length) {
      this.setState(
        {
          loading: true,
        },
        () => this.forceUpdate()
      );
      const req = {
        user_id: this.state.loginUserData.user_id,
        firstname: this.state.profileSetting.first_name,
        middlename: this.state.profileSetting.middle_name,
        lastname: this.state.profileSetting.last_name,
        mobile_number: this.state.profileSetting.mobile_number,
        country: this.state.profileSetting.country,
        cognito_username: this.state.cognitoUsername ? this.state.cognitoUsername : "",
        mfa_enable: !!this.state.profileSetting.mfa_enabled
      };

      this.setState({ loading: !this.state.loading,fieldChanged:false});
      this.props.updateUserProfile(this.props.apolloClient.client, req, this.props.history);
    } else {
      this.setState({
        errors: errors,
        loading: false

      }, () => this.forceUpdate());
    }
  };

  //event call on change phone number 
  changePhone = (value: any, country: any) => {
    this.setState(
      {
        profileSetting: {
          ...this.state.profileSetting,
          "mobile_number": value,
          "country": country.countryCode,
        }
      },
      () => this.forceUpdate()
    );
  };

  //api hit of user profile data
  getUserProfile = () => {
    const req = {
      user_id: this.state.loginUserData.user_id,
    };
    this.props.getUserProfile(this.props.apolloClient.client, req, this.props.history);
  };

  //api hit of user preferences data
  getUserPreferences = () => {
    const req = {
      user_id: this.state.loginUserData.user_id,
    };
    this.props.getUserPreferences(this.props.apolloClient.client, req, this.props.history);
  }

  //function call on password eye icon
  togglePasswordVisibility = () => {
    const { isPasswordShown } = this.state;
    this.setState({ isPasswordShown: !isPasswordShown });
  };
  togglePasswordVisibilityNewPass = () => {
    const { isPasswordNewPass } = this.state;
    this.setState({ isPasswordNewPass: !isPasswordNewPass });
  };
  togglePasswordVisibilityForAgain = () => {
    const { isPasswordShownAgain } = this.state;
    this.setState({ isPasswordShownAgain: !isPasswordShownAgain });
  };

  //validate current password on key up
  validateCurrentPass = (event: any) => {
    const input = event.target.value;
    const errors: any = {};
    if (!input) {
      errors[event.target.name] = "Please enter current password";
    } else { errors[event.target.name] = "" }
    this.setState({ [event.target.name]: event.target.value })
    this.setState(
      {
        errors: {
          ...this.state.errors,
          [event.target.name]: errors[event.target.name]
        }
      },
      () => this.forceUpdate()
    );

  };

  //validate new password on key up
  validateNewPass = (event: any) => {
    const fieldValue = event.target.value;
    if (fieldValue === this.state.newPasswordAgain) {
      this.setState({ is_confirm: true });
    } else { this.setState({ is_confirm: false }); }
    const rules = [
      {
        Pattern: "[A-Z]",
        Target: "UpperCase",
      },
      {
        Pattern: "[a-z]",
        Target: "LowerCase",
      },
      {
        Pattern: "[0-9]",
        Target: "Numbers",
      },
      // {
      //   Pattern: "[ .!@#$%^&*|]",
      //   Target: "SpecialCharacter",
      // },
    ];
    if (fieldValue.length > 7) {
      this.setState({
        is_length: true,
      }, () => {
        this.forceUpdate();
      });
    } else {
      this.setState(
        { is_length: false, },
        () => { this.forceUpdate(); }
      );
    }

    for (let i = 0; i < rules.length; i++) {
      if (new RegExp(rules[i].Pattern).test(fieldValue)) {
        if (rules[i].Target === "UpperCase") {
          this.setState({
            is_uppercase: true,
          });
        } else if (rules[i].Target === "LowerCase") {
          this.setState({
            is_lowercase: true,
          });
        } else if (rules[i].Target === "Numbers") {
          this.setState({
            is_number: true,
          });
        }
        // else if (rules[i].Target === "SpecialCharacter") {
        //   this.setState({
        //     is_special_character: true,
        //   });
        // }
      }
      if (!new RegExp(rules[i].Pattern).test(fieldValue)) {
        if (rules[i].Target === "UpperCase") {
          this.setState({
            is_uppercase: false,
          });
        } else if (rules[i].Target === "LowerCase") {
          this.setState({
            is_lowercase: false,
          });
        } else if (rules[i].Target === "Numbers") {
          this.setState({
            is_number: false,
          });
        }
        //  else if (rules[i].Target === "SpecialCharacter") {
        //   this.setState({
        //     is_special_character: false,
        //   });
        // }
      }
    }

    const input = event.target.value
    const errors: any = {};
    if (!input) {
      errors[event.target.name] = "Please enter new password";
    } else { errors[event.target.name] = "" }

    this.setState({ [event.target.name]: event.target.value })
    this.setState({
      errors: {
        ...this.state.errors,
        [event.target.name]: errors[event.target.name]
      }
    }, () => this.forceUpdate());
  };

  //validate new password and repeat password on key up of repeat password 
  validateConfimPassword = (event: any) => {
    const fieldValue = event.target.value;
    if (fieldValue.length !== 0) {
      this.setState({
        newPasswordAgain: event.target.value,
      });
      const x = this.state.NewPass;
      if (x === fieldValue) {
        this.setState(
          {
            is_confirm: true,
          },
          // function () { }
        );
      } else {
        this.setState({
          is_confirm: false,
        },
          // function () { }
        );
      }
    }
  };

  //function call on change password button
  changePassword = (e: any) => {
    e.preventDefault()
    const formData = {
      CurrentPass: this.state.CurrentPass,
      NewPass: this.state.NewPass
    };
    const validateError = ValidateForm.validateFormProfile(formData)
    if (!Object.keys(validateError).length && this.state.is_confirm) {
      this.setState({ errors: {} })
      this.setState({ is_loaded: true });
      if (this.state.user_data.user_id) {
        const obj = {
          old_password: this.state.CurrentPass,
          new_password: this.state.NewPass,
          email: this.state.loginUserData.username
        };
        this.props.changePassWordFromProfile(this.props.apolloClient.client, obj, this.props.history);
      }
    } else {
      this.setState({ errors: validateError })
    }
  };


  onChangeMobile = (event: any, value: any) => {
    const input = event
    const errors: any = {};
    if (input) {
      if (input.length < 8) {
        errors["mobile"] = "Please enter valid mobile number";
      } else { errors["mobile"] = "" }
    } else {
      errors["mobile"] = "Please enter valid mobile number";
    }
    this.setState(
      {
        errors: {
          ...this.state.errors,
          "mobile": errors["mobile"],
        },
        profileSetting: {
          ...this.state.profileSetting,
          "country": value.countryCode,
          "mobile_number": event
        }
      },
      () => this.forceUpdate()
    );
    this.setState({
      fieldChanged:true
    })
  };

  onChange = (event: any) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  checkPassword = (event: any) => {
    const input = event.target.value
    const errors: any = {};
    if (!input) {
      errors[event.target.name] = "Please enter current password";
    } else { errors[event.target.name] = "" }

    this.setState(
      {
        errors: {
          ...this.state.errors,
          [event.target.name]: errors[event.target.name]
        },
        profileSetting: {
          ...this.state.profileSetting,
          [event.target.name]: event.target.value,
        }
      },
      () => this.forceUpdate()
    );
  }

  selectTimeZone(event: any) {
    this.setState(
      {
        profileSetting: {
          ...this.state.profileSetting,
          "timezone_value": event,
        },
      },
      () => {
        this.forceUpdate()
        if (event) {

          const newTimezone = event ? event : Intl.DateTimeFormat().resolvedOptions().timeZone;

          const preferencesData = this.state.userPreferencesData
          let pf_id = '';

          pf_id = (preferencesData.filter((data: any) => data.preference_name === "TIMEZONE"))[0]?.preference_id

          if (pf_id) {
            const req = {
              preference_value: true,
              preference_id: pf_id,
              preference_information: newTimezone,
              user_id: this.state.loginUserData.user_id
            };

            this.props.updateUserPreference(this.props.apolloClient.client, req, this.props.history);
            this.setState({
              errors: {},

            }, () => this.forceUpdate());
          }
        } else {
          this.setState({
            errors: { "timezone": "Select timezone" },

          }, () => this.forceUpdate());
        }
      }
    );
  }

  validateEmail(event: any) {
    const input = event.target.value
    const errors: any = {};
    //this.setState({ [event.target.name]: event.target.value }, () => this.forceUpdate())

    if (!input) {
      errors["email"] = "Please enter your email Address.";
    } else { errors["email"] = "" }

    if (typeof input !== "undefined") {
      const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
      if (!pattern.test(input)) {
        errors["email"] = "Please enter your email Address.";
      } else { errors["email"] = "" }
    }

    this.setState(
      {
        profileSetting: {
          ...this.state.profileSetting,
          [event.target.name]: event.target.value,
        },
        errors: {
          ...this.state.errors,
          "email": errors["email"],
        },
      },
      () => this.forceUpdate()
    );
  }
  handleClickOpen = () => {
    this.setState({
      open: true,
      is_loaded: false,
      loading: false,
      screen_loader: false,
      is_length: false,
      is_number: false,
      is_lowercase: false,
      is_uppercase: false,
      // is_special_character: false,
      is_confirm: false,
      newPasswordAgain: "",
      CurrentPass: "",
      NewPass: ""
    })
  };
  handleClose = () => {
    this.setState({
      open: false,
      is_length: false,
      is_uppercase: false,
      is_lowercase: false,
      is_number: false,
      is_confirm: false,
      // is_special_character: false
    })
  };
  setAvatar = (image: any) => {
    //prep the files
    this.setState(
      {
        profileSetting: {
          ...this.state.profileSetting,
          "imageSrc": URL.createObjectURL(image[0]),
          "image": image
        },

      },
      () => this.forceUpdate()
    );

  }

  changeMfaSetting = (event: any, checked: any) => {
    this.setState({
      profileSetting: {
        ...this.state.profileSetting,
        [event.target.name]: checked,
      },
      fieldChanged:true
    })
    // let request = {
    //   user_id: this.state.loginUserData.user_id,
    //   mfa: checked,
    // };
    // this.props.updateMfaSetting(this.props.apolloClient.client, request);
  };

  getName = () => {
    if (this.state.firstName && this.state.lastName) {
      return `${this.state.firstName} ${this.state.lastName}`;
    }
    return `${this.state.loginUserData.first_name} ${this.state.loginUserData.last_name}`
  };

  getTitle = () => {
    if (this.state.userPreferencesData.length > 0) {
      const titleObj = this.state.userPreferencesData.find((data: any) => data.preference_name === 'TITLE');
      return titleObj ? titleObj.preference_information : ''
    }
    return '';
  };

  changeAudiencePreferences = (event: any, checked: any) => {
    this.setState({
      profileSetting: {
        ...this.state.profileSetting,
        [event.target.name]: checked
      }
    });

    const preferencesData = this.state.userPreferencesData;
    const pf_id = preferencesData.filter((data: any) => data.preference_name === event.target.name).length ? (preferencesData.filter((data: any) => data.preference_name === event.target.name))[0].preference_id : "";
    if (pf_id) { // updating
      const req = {
        preference_value: checked,
        preference_id: pf_id,
        preference_information: '',
        user_id: this.state.loginUserData.user_id
      };
      this.props.updateUserPreference(this.props.apolloClient.client, req, this.props.history);
    } else { // creating
      const req = {
        preference_information: '',
        preference_value: checked,
        preference_type: '11',
        preference_name: event.target.name,
        user_id: this.state.loginUserData.user_id
      };
      this.props.createUserPreference(this.props.apolloClient.client, req, this.props.history);
    }

    if (event.target.name === 'HELPTOMEASURE' && checked && !this.state.loginUserData.disable_transactional_emails) {
      const request = {
        name: this.getName(),
        email: Config.SUCCESS_EMAIL,
        user_email: this.state.loginUserData.username,
        title: this.getTitle(),
        organization: this.state.newDepartmentAlias ? this.state.newDepartmentAlias : this.state.loginUserData.department_alias,
        experience_id: ''
      };

      this.props.sendNeedHelpEmail(this.props.apolloClient.client, request, () => {})
    }

    if (event.target.name === 'WANTTOPARTICIPANTE') {
      const req = {
        user_id: Number(this.state.loginUserData.user_id),
        metrix_type: 'EXPERIENCE_CREATE_SETTING',
        metrix_value: {
          compatible: checked ? 0 : 2,
          save_setting: !this.state.profileSetting.ASKEVERYTIME
        }
      };
      this.props.mutationUpdateUserMetricValue(this.props.apolloClient.client, req);
    }

    if (event.target.name === 'ASKEVERYTIME') {
      const req = {
        user_id: Number(this.state.loginUserData.user_id),
        metrix_type: 'EXPERIENCE_CREATE_SETTING',
        metrix_value: {
          compatible: this.state.profileSetting.WANTTOPARTICIPANTE ? 0 : 2,
          save_setting: !checked
        }
      };
      this.props.mutationUpdateUserMetricValue(this.props.apolloClient.client, req);
    }
  };

  // when toggle profile picture upload
  handleProfilePictureToggle = () => {
    this.setState({
      openProfilePicture:!this.state.openProfilePicture,
      selectedProfileImage:false,
      uploadProfileImageError:""
    })
  };

  // when user drop image
  dropImage = (image:any) => {
    if(image){
      this.setState({
        selectedProfileImage:image,
        uploadProfileImageError:""
      })
    }
  }

  // upload Profile Image to s3bucket 
  uploadProfileImage = () => {
    if(this.state.selectedProfileImage){
      const request = {
        userid: this.state.loginUserData.user_id,
        image:this.state.selectedProfileImage
      }
      this.setState({
        is_loaded:true
      })
      this.props.updateUserProfilePicture(this.props.apolloClient.client, request);
    }
  }
  // creator onboarding button
  creatorOnboardingButton = () => {
    if(this.state.loginUserData && this.state.loginUserData.role_access){
      const creator_onboarding = this.state.loginUserData.role_access.filter((val: any) => val.access_name === "creator_onboarding")
      if (creator_onboarding.length > 0 && creator_onboarding[0].access_value) {
        return (
          <>
            <br /><br />
            <Link to={{pathname: "/creator/onboarding", state: { prevPath: window.location.pathname }}} style={{textDecoration:"none"}} >
              <Button variant="contained" color="primary" >
                Creator Onboarding
              </Button>
            </Link>
          </>
        )
      }
    }
  }

  // check redirect to page
  handleBlockedNavigation = (e:any) => {
    if(this.state.fieldChanged){
      this.setState({confirmationLeavePage:e.pathname})
      return false
    } else {
      this.setState({confirmationLeavePage:false})
      return true
    }
  }

  // redirect to new page after confirm
  redirectToNewPage = () => {
    let page = "/"
    if(this.state.confirmationLeavePage){
      page = this.state.confirmationLeavePage
      if (page === '/user/profile/preferences' || page === '/user/profile/account' || page === '/subscriber/user/profile/preferences' || page === '/subscriber/user/profile/account') {
        this.getUserProfile();
        this.getUserPreferences();
      }
    }
    this.setState({
      fieldChanged:false,
      errors: { email: "", CurrentPass: "", NewPass: "", mobile: "", timezone: "", first_name: "", last_name: "" },
    },()=>{
      this.props.history.push(`${page}`)
      this.setState({confirmationLeavePage:false})
    })
  }

  render() {
    const {
      isPasswordShown,
      isPasswordNewPass,
      isPasswordShownAgain,
      profileSetting,
      errors,
      open,
      is_confirm,
      is_loaded,
      is_length,
      is_number,
      is_uppercase,
      is_lowercase,
      openProfilePicture,
      selectedProfileImage,
      uploadProfileImageError,
      userProfile,
      isTrial,
      isTeamOwner
    } = this.state;
    const { classes } = this.props;
    const { selectedTab } = this.state;

    return (
      <Box mt={3}>
          <Dialog
            open={open}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">{"Change password"}</DialogTitle>
            <DialogContent>
              <Grid container>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <TextField
                    InputLabelProps={{
                      classes: {
                        root: classes.label,
                        focused: classes.focusedLabel,
                        error: classes.erroredLabel
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.underline,
                        error: classes.error
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="password-visible-btn"
                            onClick={this.togglePasswordVisibility}
                            aria-label="toggle password visibility"
                          >
                            {
                              isPasswordShown ? <img src='/assets/images/eye-show-visible.svg' alt="show"/>
                                : <img src='/assets/images/eye-hidden.svg' alt="hidden"/>
                            }
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    margin="normal"
                    className={classes.passwordInput}
                    label='Current Password'
                    type={isPasswordShown ? "text" : "password"} // <-- This is where the magic happens
                    onKeyUp={this.validateCurrentPass.bind(this)}
                    error={!!(errors && errors.CurrentPass)}
                    helperText={errors.CurrentPass ? errors.CurrentPass : ""}
                    name="CurrentPass"
                  />
                  <br />
                  <TextField
                    InputLabelProps={{
                      classes: {
                        root: classes.label,
                        focused: classes.focusedLabel,
                        error: classes.erroredLabel
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.underline,
                        error: classes.error
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="password-visible-btn"
                            onClick={this.togglePasswordVisibilityNewPass}
                            aria-label="toggle password visibility"
                          >
                            {
                              isPasswordNewPass ? <img src='/assets/images/eye-show-visible.svg' alt="show"/>
                                : <img src='/assets/images/eye-hidden.svg' alt="hidden"/>
                            }
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    margin="normal"
                    label='New password'
                    className={classes.passwordInput}
                    type={isPasswordNewPass ? "text" : "password"} // <-- This is where the magic happens
                    //onChange={(event) => this.checkPassword(event)}
                    name="NewPass"
                    onChange={this.validateNewPass}
                  />
                  <div className={classes.passwordCheckRow}>
                    {is_length ? <CheckCircleOutlineIcon style={{ color: green[500], marginRight: 10 }} /> : <CancelIcon style={{ marginRight: 10 }} color="error" />}
                    Password must be at least 8 characters
                  </div>
                  <div className={classes.passwordCheckRow}>
                    {is_number ? <CheckCircleOutlineIcon style={{ color: green[500], marginRight: 10 }} /> : <CancelIcon style={{ marginRight: 10 }} color="error" />}
                    Password must contain at least one number
                  </div>
                  <div className={classes.passwordCheckRow}>
                    {is_uppercase ? <CheckCircleOutlineIcon style={{ color: green[500], marginRight: 10 }} /> : <CancelIcon style={{ marginRight: 10 }} color="error" />}
                    Password must contain at least one upper-case letter
                  </div>
                  <div className={classes.passwordCheckRow}>
                    {is_lowercase ? <CheckCircleOutlineIcon style={{ color: green[500], marginRight: 10 }} /> : <CancelIcon style={{ marginRight: 10 }} color="error" />}
                    Password must contain at least one lower-case letter
                  </div>
                  {/* <div className={classes.passwordCheckRow}>
                    {is_special_character ? <CheckCircleOutlineIcon style={{ color: green[500], marginRight: 10 }} /> : <CancelIcon style={{ marginRight: 10 }} color="error" />}
                    Password must contain at least one symbol or whitespace
                  </div> */}

                  <TextField
                    InputLabelProps={{
                      classes: {
                        root: classes.label,
                        focused: classes.focusedLabel,
                        error: classes.erroredLabel
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.underline,
                        error: classes.error
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="password-visible-btn"
                            onClick={this.togglePasswordVisibilityForAgain}
                            aria-label="toggle password visibility"
                          >
                            {
                              isPasswordShownAgain ? <img src='/assets/images/eye-show-visible.svg' alt="show"/>
                                : <img src='/assets/images/eye-hidden.svg' alt="hidden"/>
                            }
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    margin="normal"
                    className={classes.passwordInput}
                    label='Repeat password'
                    type={isPasswordShownAgain ? "text" : "password"} // <-- This is where the magic happens
                    onKeyUp={this.validateConfimPassword.bind(this)}
                  />

                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} variant="contained" >
                Cancel
              </Button>
              <Button
                className={(is_loaded || !(is_confirm && is_length && is_number && is_uppercase && is_lowercase)) ? "" : "password-save-btn"}
                variant="contained"
                disabled={
                  is_loaded || !(is_confirm && is_length && is_number && is_uppercase && is_lowercase )
                }
                onClick={this.changePassword}
              >
                {is_loaded && <CircularProgress color="inherit" size={20}/>}
                {!is_loaded && "SAVE"}
              </Button>

            </DialogActions>
          </Dialog>

          <form noValidate onSubmit={this.handleProfileSubmit}>
            <Grid container spacing={2}>
              {selectedTab === 'account' && <div>

                <p className='profile-title'>
                  Basic Info
                </p>
                <Avatar
                  className={classes.avatar}
                  src={userProfile}
                  alt="Avatar"
                  onClick={this.handleProfilePictureToggle}
                />

                <Grid container direction='row'>
                  <Grid item>
                    <CssTextField
                      margin="normal"
                      fullWidth
                      id="first_name"
                      label="First Name"
                      name="first_name"
                      value={UtilService.capitalizeFirstLetter(profileSetting.first_name)}
                      onChange={this.handleChange}
                      error={!!(errors && errors.first_name)}
                      helperText={errors.first_name}
                    />
                  </Grid>
                  <Grid item>
                    <CssTextField
                      margin="normal"
                      fullWidth
                      id="last_name"
                      label="Last Name"
                      name="last_name"
                      onChange={this.handleChange}
                      value={UtilService.capitalizeFirstLetter(profileSetting.last_name)}
                      error={errors && errors.last_name ? true : false}
                      helperText={errors.last_name}
                    />
                  </Grid>
                </Grid>

                <Grid container direction='row'>
                  <Grid item>
                    <CssTextField
                      value={profileSetting.email}
                      margin="normal"
                      id="email"
                      fullWidth
                      label="Email"
                      name="email"
                      onChange={(event: any) => { this.validateEmail(event) }}
                      error={!!(errors && errors.email)}
                      helperText={errors.email}
                      disabled
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <LockOutlinedIcon style={{ fontSize: 16, color: '#697683' }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <label>Mobile</label>
                    <br />
                    <span className="input-group-text">

                <PhoneInput
                  value={profileSetting.mobile_number}
                  country={'us'}
                  onChange={(event, val) => this.onChangeMobile(event, val)}
                  countryCodeEditable={false}
                  enableSearch={true}
                />
                      {(errors.mobile && errors.mobile) && (
                        <span className="error-message">{errors.mobile}</span>
                      )}
              </span>

                  </Grid>
                </Grid>

                <Grid>
                  <Dialog
                    open={openProfilePicture}
                    aria-labelledby="responsive-dialog-title"
                  >
                    <DialogTitle id="responsive-dialog-title">Profile Picture</DialogTitle>
                    <DialogContent>
                      <Grid container>
                        <Grid item xs={12} style={{ textAlign: "center" }}>
                          <CustomDropzone multipleUpload={false} acceptedFiles={[".gif",".png",".jpg",".jpeg"]} onDrop={this.dropImage}>
                            Drop your image here, or Browse
                          </CustomDropzone>
                          {selectedProfileImage && (
                            <img src={window.URL.createObjectURL(selectedProfileImage[0])} width="100" className={classes.img} alt="{profile}"></img>
                          )}
                          {uploadProfileImageError && (
                            <span className="error-message"><br />{uploadProfileImageError}</span>
                          )}
                        </Grid>
                      </Grid>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.handleProfilePictureToggle} variant="contained" >
                        Cancel
                      </Button>
                      <Button
                        className={selectedProfileImage?"password-save-btn":""}
                        variant="contained"
                        disabled={
                          is_loaded || !(selectedProfileImage)
                        }
                        onClick={this.uploadProfileImage}
                      >
                        {is_loaded && <CircularProgress color="inherit" size={20}/>}
                        {!is_loaded && "UPLOAD"}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Grid>

                <br />

                <Box mt={4} mb={3}>
                  <p className='profile-title'>
                    Security
                  </p>
                </Box>

                {this.state.loginUserData && this.state.loginUserData.auth_type === 0 && (
                  <Button variant="contained" color="primary" onClick={this.handleClickOpen}>
                    Change Password
                  </Button>
                )}

                <Box mt={2} />
                <FormControlLabel
                  control={
                    <Switch
                      checked={
                        profileSetting.mfa_enabled
                      }
                      onChange={(checked, event) =>
                        this.changeMfaSetting(checked, event)
                      }
                      name="mfa_enabled"
                      color="primary"
                    />
                  }
                  label="Multi-Factor Authentication"
                />
                <br />

                <Box mt={5}>
                  <p className='profile-title'>
                    Your Team
                  </p>
                </Box>

                <CssTextField
                  value={profileSetting.organization}
                  margin="normal"
                  id="organization"
                  fullWidth
                  label="Organization"
                  name="organization"
                  onChange={(e) => (isTrial && isTeamOwner) && this.handleChange(e)}
                  disabled={!isTrial || (isTrial && !isTeamOwner)}
                  InputProps={{
                    endAdornment: (
                      (!isTrial || (isTrial && !isTeamOwner)) &&
                      <InputAdornment position="end">
                        <LockOutlinedIcon style={{ fontSize: 16, color: '#697683' }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <br />
                <CssTextField
                  margin="normal"
                  id="role"
                  fullWidth
                  multiline
                  label="Role"
                  name="role"
                  onChange={this.handleChange}
                  value={this.state.profileSetting.role}
                  disabled
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <LockOutlinedIcon style={{ fontSize: 16, color: '#697683' }} />
                      </InputAdornment>
                    ),
                  }}
                />

                <br /><br />

                {this.state.fieldChanged && (
                  <Button type="submit" variant="contained" color="primary" disabled={this.state.loading} className={classes.updateBtn}>
                    Update
                  </Button>
                )}

              </div>}

              {/*{selectedTab === 'notifications' &&*/}
              {/*<div>*/}
              {/*  <p className='profile-title' color='textPrimary'>*/}
              {/*    Notifications*/}
              {/*  </p>*/}

              {/*  <FormControlLabel*/}
              {/*    control={*/}
              {/*      <Switch*/}
              {/*        checked={this.state.profileSetting.DESKNOTIFY}*/}
              {/*        onChange={(checked, event) =>*/}
              {/*          this.changeSwitch(checked, event)*/}
              {/*        }*/}
              {/*        name="DESKNOTIFY"*/}
              {/*        color="primary"*/}
              {/*      />*/}
              {/*    }*/}
              {/*    label="Desktop Notifications"*/}
              {/*  />*/}

              {/*  <br />*/}
              {/*  <FormControlLabel*/}
              {/*    control={*/}
              {/*      <Switch*/}
              {/*        checked={this.state.profileSetting.EMAILNOTIFY}*/}
              {/*        onChange={(checked, event) =>*/}
              {/*          this.changeSwitch(checked, event)*/}
              {/*        }*/}
              {/*        name="EMAILNOTIFY"*/}
              {/*        color="primary"*/}
              {/*      />*/}
              {/*    }*/}
              {/*    label="Email Notifications"*/}
              {/*  />*/}

              {/*  <br />*/}

              {/*  <Box mt={2} ml={1}>*/}
              {/*    <div className={clsx(classes.advancedView, !this.state.profileSetting.EMAILNOTIFY && classes.deactive)}>*/}
              {/*      <FormControlLabel*/}
              {/*        control={*/}
              {/*          <Switch*/}
              {/*            checked={*/}
              {/*              this.state.profileSetting.MARKETINGEMAIL*/}
              {/*            }*/}
              {/*            onChange={(checked, event) =>*/}
              {/*              this.changeSwitch(checked, event)*/}
              {/*            }*/}
              {/*            name="MARKETINGEMAIL"*/}
              {/*            color="primary"*/}
              {/*          />*/}
              {/*        }*/}
              {/*        label="Marketing Emails"*/}
              {/*      />*/}

              {/*      <br />*/}
              {/*      <FormControlLabel*/}
              {/*        control={*/}
              {/*          <Switch*/}
              {/*            checked={*/}
              {/*              this.state.profileSetting.RESOURCEEMAIL*/}
              {/*            }*/}
              {/*            onChange={(checked, event) =>*/}
              {/*              this.changeSwitch(checked, event)*/}
              {/*            }*/}
              {/*            name="RESOURCEEMAIL"*/}
              {/*            color="primary"*/}
              {/*          />*/}
              {/*        }*/}
              {/*        label="Immersion Resources"*/}
              {/*      />*/}

              {/*      <br />*/}
              {/*      <FormControlLabel*/}
              {/*        control={*/}
              {/*          <Switch*/}
              {/*            checked={*/}
              {/*              this.state.profileSetting.AGGREGATEEMAIL*/}
              {/*            }*/}
              {/*            onChange={(checked, event) =>*/}
              {/*              this.changeSwitch(checked, event)*/}
              {/*            }*/}
              {/*            name="AGGREGATEEMAIL"*/}
              {/*            color="primary"*/}
              {/*          />*/}
              {/*        }*/}
              {/*        label="Participant Progress"*/}
              {/*      />*/}

              {/*      <br />*/}
              {/*      <FormControlLabel*/}
              {/*        control={*/}
              {/*          <Switch*/}
              {/*            checked={*/}
              {/*              this.state.profileSetting.PERSONALEMAIL*/}
              {/*            }*/}
              {/*            onChange={(checked, event) =>*/}
              {/*              this.changeSwitch(checked, event)*/}
              {/*            }*/}
              {/*            name="PERSONALEMAIL"*/}
              {/*            color="primary"*/}
              {/*          />*/}
              {/*        }*/}
              {/*        label="New Result" // My Personal Measurement Results*/}
              {/*      />*/}
              {/*    </div>*/}
              {/*  </Box>*/}

              {/*  <br />*/}
              {/*  <FormControlLabel*/}
              {/*    control={*/}
              {/*      <Switch*/}
              {/*        checked={this.state.profileSetting.APPNOTIFY}*/}
              {/*        onChange={(checked, event) =>*/}
              {/*          this.changeSwitch(checked, event)*/}
              {/*        }*/}
              {/*        name="APPNOTIFY"*/}
              {/*        color="primary"*/}
              {/*      />*/}
              {/*    }*/}
              {/*    label="Application Notifications"*/}
              {/*  />*/}

              {/*  <br />*/}
              {/*  <FormControlLabel*/}
              {/*    control={*/}
              {/*      <Switch*/}
              {/*        checked={this.state.profileSetting.SMSNOTIFY}*/}
              {/*        onChange={(checked, event) =>*/}
              {/*          this.changeSwitch(checked, event)*/}
              {/*        }*/}
              {/*        name="SMSNOTIFY"*/}
              {/*        color="primary"*/}
              {/*      />*/}
              {/*    }*/}
              {/*    label="SMS Notifications"*/}
              {/*  />*/}

              {/*</div>}*/}

              {selectedTab === 'preferences' &&
              <Grid>

                <p className='profile-title'>
                  Experience Preferences
                </p>
                <p className={classes.timezone}>
                  Time Zone
                </p>
                <TimezonePicker
                  value={this.props.authUser.timezone}
                  className="timezone"
                  onChange={(event: any) => this.selectTimeZone(event)}
                  inputProps={{
                    placeholder: 'Select Timezone...',
                    name: 'timezone',
                  }}
                />

                {(errors.timezone && errors.timezone) && (
                  <span className="error-message">{errors.timezone}</span>
                )}

                {/*<Box mt={2} mb={2}>*/}
                {/*  <Typography*/}
                {/*    className={advanced ? classes.actived : classes.advanced}*/}
                {/*    onClick={() => this.setState({ advanced: !advanced })}*/}
                {/*  >*/}
                {/*    advanced {'>'}*/}
                {/*  </Typography>*/}
                {/*</Box>*/}


                {/*{*/}
                {/*  advanced &&*/}
                {/*  <div className={classes.advancedView}>*/}
                {/*    <Box mb={2}>*/}
                {/*      <Typography className={classes.advanced}>*/}
                {/*        Types of Experiences I’m Measuring*/}
                {/*      </Typography>*/}
                {/*    </Box>*/}

                {/*    <FormControlLabel*/}
                {/*      control={*/}
                {/*        <Switch*/}
                {/*          checked={*/}
                {/*            this.state.profileSetting.AUTOJOIN*/}
                {/*          }*/}
                {/*          onChange={(checked, event) =>*/}
                {/*            this.changeSwitch(checked, event)*/}
                {/*          }*/}
                {/*          name="AUTOJOIN"*/}
                {/*          color="primary"*/}
                {/*        />*/}
                {/*      }*/}
                {/*      label="Auto Join"*/}
                {/*    />*/}
                {/*    <br />*/}
                {/*    <FormControlLabel*/}
                {/*      control={*/}
                {/*        <Switch*/}
                {/*          checked={*/}
                {/*            this.state.profileSetting.AUTOSTART*/}
                {/*          }*/}
                {/*          onChange={(checked, event) =>*/}
                {/*            this.changeSwitch(checked, event)*/}
                {/*          }*/}
                {/*          name="AUTOSTART"*/}
                {/*          color="primary"*/}
                {/*        />*/}
                {/*      }*/}
                {/*      label="Auto Start"*/}
                {/*    />*/}
                {/*    <br />*/}
                {/*    <FormControlLabel*/}
                {/*      control={*/}
                {/*        <Switch*/}
                {/*          checked={*/}
                {/*            this.state.profileSetting.ALLOWPERSONAL*/}
                {/*          }*/}
                {/*          onChange={(checked, event) =>*/}
                {/*            this.changeSwitch(checked, event)*/}
                {/*          }*/}
                {/*          name="ALLOWPERSONAL"*/}
                {/*          color="primary"*/}
                {/*        />*/}
                {/*      }*/}
                {/*      label="Allow Personal Analysis"*/}
                {/*    />*/}
                {/*    <br />*/}
                {/*    <FormControlLabel*/}
                {/*      control={*/}
                {/*        <Switch*/}
                {/*          checked={*/}
                {/*            this.state.profileSetting*/}
                {/*              .ALLOWAGGREGATE*/}
                {/*          }*/}
                {/*          onChange={(checked, event) =>*/}
                {/*            this.changeSwitch(checked, event)*/}
                {/*          }*/}
                {/*          name="ALLOWAGGREGATE"*/}
                {/*          color="primary"*/}
                {/*        />*/}
                {/*      }*/}
                {/*      label="Allow Aggregate Analysis"*/}
                {/*    />*/}
                {/*    <br />*/}

                {/*    <Box mt={3} mb={2}>*/}
                {/*      <Typography className={classes.advanced}>*/}
                {/*        Types of Analysis I’m Doing*/}
                {/*      </Typography>*/}
                {/*    </Box>*/}

                {/*    <FormControlLabel*/}
                {/*      control={*/}
                {/*        <Switch*/}
                {/*          checked={*/}
                {/*            this.state.profileSetting.ANONYMOUS*/}
                {/*          }*/}
                {/*          onChange={(checked, event) =>*/}
                {/*            this.changeSwitch(checked, event)*/}
                {/*          }*/}
                {/*          name="ANONYMOUS"*/}
                {/*          color="primary"*/}
                {/*        />*/}
                {/*      }*/}
                {/*      label="Anonymize My Data"*/}
                {/*    />*/}
                {/*    <br />*/}
                {/*    <FormControlLabel*/}
                {/*      control={*/}
                {/*        <Switch*/}
                {/*          checked={*/}
                {/*            this.state.profileSetting.MODERATED*/}
                {/*          }*/}
                {/*          onChange={(checked, event) =>*/}
                {/*            this.changeSwitch(checked, event)*/}
                {/*          }*/}
                {/*          name="MODERATED"*/}
                {/*          color="primary"*/}
                {/*        />*/}
                {/*      }*/}
                {/*      label="Enable moderated events"*/}
                {/*    />*/}
                {/*    <br />*/}
                {/*    <FormControlLabel*/}
                {/*      control={*/}
                {/*        <Switch*/}
                {/*          checked={*/}
                {/*            this.state.profileSetting.ASYNC*/}
                {/*          }*/}
                {/*          onChange={(checked, event) =>*/}
                {/*            this.changeSwitch(checked, event)*/}
                {/*          }*/}
                {/*          name="ASYNC"*/}
                {/*          color="primary"*/}
                {/*        />*/}
                {/*      }*/}
                {/*      label="Enable asynchronous events"*/}
                {/*    />*/}
                {/*    <br />*/}
                {/*    <FormControlLabel*/}
                {/*      control={*/}
                {/*        <Switch*/}
                {/*          checked={*/}
                {/*            this.state.profileSetting.VIDEOSECURITY*/}
                {/*          }*/}
                {/*          onChange={(checked, event) =>*/}
                {/*            this.changeSwitch(checked, event)*/}
                {/*          }*/}
                {/*          name="VIDEOSECURITY"*/}
                {/*          color="primary"*/}
                {/*        />*/}
                {/*      }*/}
                {/*      label="Enhanced video security"*/}
                {/*    />*/}
                {/*    {this.creatorOnboardingButton()}*/}
                {/*  </div>*/}
                {/*  }*/}

                {/*<Box mt={5} mb={2}>*/}
                {/*  <p className='profile-title'>*/}
                {/*    Integrations*/}
                {/*  </p>*/}
                {/*</Box>*/}
                {/*<FormControlLabel*/}
                {/*  control={*/}
                {/*    <Switch*/}
                {/*      checked={*/}
                {/*        this.state.profileSetting.CALENDAR*/}
                {/*      }*/}
                {/*      onChange={(checked, event) =>*/}
                {/*        this.changeSwitch(checked, event)*/}
                {/*      }*/}
                {/*      name="CALENDAR"*/}
                {/*      color="primary"*/}
                {/*    />*/}
                {/*  }*/}
                {/*  label="Calendar Integration"*/}
                {/*/>*/}
                <p className='profile-title' style={{ marginTop: '80px' }}>
                  Audience Preferences
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={
                          profileSetting.HELPTOMEASURE
                        }
                        onChange={(event, checked) =>
                          this.changeAudiencePreferences(event, checked)
                        }
                        name="HELPTOMEASURE"
                        color='primary'
                      />
                    }
                    label={
                      <div className={classes.toggleLabel}>I need help finding participants to measure</div>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={
                          profileSetting.WANTTOPARTICIPANTE
                        }
                        onChange={(event, checked) =>
                          this.changeAudiencePreferences(event, checked)
                        }
                        name="WANTTOPARTICIPANTE"
                        color='primary'
                      />
                    }
                    label={
                      <div className={classes.toggleLabel}>
                        I want to participate in my own measurements (requires a <a className={classes.anchorLink} href={`${Config.INTERCOM_URL}/articles/5321917-phone-smartwatch-and-fitness-device-requirements`} target='_blank' rel="noreferrer" >compatible smartwatch / fitness sensor</a>)
                      </div>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={
                          profileSetting.ASKEVERYTIME
                        }
                        onChange={(event, checked) =>
                          this.changeAudiencePreferences(event, checked)
                        }
                        name="ASKEVERYTIME"
                        color='primary'
                      />
                    }
                    label={
                      <div className={classes.toggleLabel}>Ask me every time I measure a new experience to confirm the above Audience Preferences</div>
                    }
                  />
                </div>
              </Grid>}

              {selectedTab === 'billing' &&
              <div>
                <p className='profile-title' color='textPrimary'>
                  Billing
                </p>

              </div>}
            </Grid>

          </form>
          {
            (this.state.screen_loader || this.state.loading) &&
            <Box className="loader" mt={3}>
              <CircularProgress color="inherit" />
            </Box>
          }

          <Prompt
            when={this.state.fieldChanged}
            message={this.handleBlockedNavigation}
          />
          <Dialog
            fullWidth={true}
            maxWidth={'xs'}
            open={!!this.state.confirmationLeavePage}
            className={classes.dialog}
          >
            <DialogTitle >
              <div className={classes.header}>Leave without updating?</div>
            </DialogTitle>
            <Divider />
            <Box mt={3} mb={3} mr={2} display='flex' justifyContent='flex-end'>
              <Button color='primary' size='small' onClick={this.redirectToNewPage} className={classes.btnOK}>
                OK
              </Button>
              <Button color='primary' size='small' onClick={()=>this.setState({confirmationLeavePage:false})} className={classes.btnCancel}>
                Cancel
              </Button>
            </Box>
          </Dialog>
        <CustomSnackBar type={this.state.snackAlertType} message={this.state.snackAlertMsg} open={this.state.isShownSnackAlert} onClose={() => this.setState({ isShownSnackAlert: false })} />
    </Box>
    );
  }
}

const mapStateToProps = (state: any) => ({
  authUser: state.authUser,
  apolloClient: state.apolloClient,
  notification: state.notification
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    getUserProfile: (client: any, request: any) => {
      dispatch(actions.getUserProfile(client, request));
    },
    getUserPreferences: (client: any, request: any) => {
      dispatch(actions.getUserPreferences(client, request));
    },

    updateUserProfile: (client: any, request: any) => {
      dispatch(actions.updateUserProfile(client, request));
    },
    createUserPreference: (client: any, request: any) => {
      dispatch(actions.createUserPreference(client, request));
    },
    updateUserPreference: (client: any, request: any) => {
      dispatch(actions.updateUserPreference(client, request));
    },
    changePassWordFromProfile: (client: any, request: any) => {
      dispatch(actions.changePasswordFromProfile(client, request));
    },
    updateMfaSetting: (client: any, request: any) => {
      dispatch(actions.updateMfaSetting(client, request));
    },
    updateUserProfilePicture: (client: any, request: any) => {
      dispatch(actions.updateUserProfilePicture(client, request));
    },
    updateDepartment: (client: any, request: any, cb: any) => {
      dispatch(actions.updateDepartment(client, request, cb))
    },
    sendNeedHelpEmail: (client: any, request: any, cb: any) => {
      dispatch(actions.sendNeedHelpEmail(client, request, cb));
    },
    mutationUpdateUserMetricValue: (client: any, request: any) => {
      dispatch(actions.mutationUpdateUserMetricValue(client, request))
    },
    getGravatarImage: (client: any, request: any) => {
      dispatch(actions.getGravatarImage(client, request))
    }
  };
};

const UserProfileComponent = withRouter(withStyles(useStyles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(UserProfile)));
export {
  UserProfileComponent
}
